import api from "./apiWithAccessToken";

export const getOnPremOnboarding = () => api.get("/onprem/admin/onboarding");
export const createOnPremOnboarding = (payload) =>
  api.post("/onprem/admin/onboarding", payload);
export const updateOnPremClient = (payload) =>
  api.patch("/onprem/admin/client", payload);
export const updateOnPremFirstAdmin = (payload) =>
  api.patch("/onprem/admin/first-admin", payload);
export const getOnPremLlmConfig = () => api.get("/onprem/admin/llm-config");
export const updateOnPremLlmConfig = (payload) =>
  api.put("/onprem/admin/llm-config", payload);
export const getOnPremLlmRuntimeOptions = () =>
  api.get("/onprem/admin/llm-runtime/options");
export const getOnPremLlmRuntimeActive = () =>
  api.get("/onprem/admin/llm-runtime/active");
export const getOnPremLlmRuntimeDrafts = () =>
  api.get("/onprem/admin/llm-runtime/drafts");
export const getOnPremLlmRuntimeProfiles = () =>
  api.get("/onprem/admin/llm-runtime/profiles");
export const createOnPremLlmRuntimeDraft = (payload) =>
  api.post("/onprem/admin/llm-runtime/drafts", payload);
export const patchOnPremLlmRuntimeDraft = (profileId, payload) =>
  api.patch(`/onprem/admin/llm-runtime/drafts/${profileId}`, payload);
export const activateOnPremLlmRuntimeDraft = (profileId) =>
  api.post(`/onprem/admin/llm-runtime/drafts/${profileId}/activate`);
export const deleteOnPremLlmRuntimeDraft = (profileId) =>
  api.delete(`/onprem/admin/llm-runtime/drafts/${profileId}`);
export const deleteOnPremLlmRuntimeProfile = (profileId) =>
  api.delete(`/onprem/admin/llm-runtime/profiles/${profileId}`);
export const replaceOnPremLlmRuntimeCredential = (payload) =>
  api.put("/onprem/admin/llm-runtime/credential", payload);
export const getOnPremLocalLlmServices = () =>
  api.get("/onprem/admin/llm-runtime/local-services");
export const getOnPremLocalLlmServiceModels = (serviceType) =>
  api.get(`/onprem/admin/llm-runtime/local-services/${serviceType}/models`);
export const getOnPremDashboard = () => api.get("/onprem/admin/dashboard");
export const getOnPremLogs = () => api.get("/onprem/admin/logs");

export function getOnPremErrorMessage(error, fallback) {
  const data = error?.response?.data;
  return data?.msg || data?.detail?.msg || data?.error || data?.message || fallback;
}

export function getOnPremValidationErrors(error) {
  const details = error?.response?.data?.detail;
  if (!Array.isArray(details)) return {};
  const errors = {};
  details.forEach((detail) => {
    const path = Array.isArray(detail.loc) ? detail.loc.slice(1).join(".") : "";
    const field = {
      client_display_name: "clientDisplayName",
      "first_admin.name": "adminName",
      "first_admin.email": "adminEmail",
      "first_admin.password": "adminPassword",
      llm_provider: "provider",
      "groq.name": "groqName",
      "groq.api_key": "groqApiKey",
    }[path];
    if (field && !errors[field]) errors[field] = detail.msg;
  });
  return errors;
}
